<template>
  <NavbarApp />
  <FlippingWords/>
   
  <Section4/>
</template>

<script>
import NavbarApp from '../components/HomePage/navbar-law.vue'
import FlippingWords from '../components/HomePage/FlippingWords.vue'

import Section4 from '../components/HomePage/section-4.vue'
export default {
  name: 'HomePage',
  components: {
    NavbarApp,
    FlippingWords,
   
    Section4,
  }
}</script>